import { FC, ReactNode } from "react";
import cn from "classnames";
import Skeleton from "react-loading-skeleton";

import { LabelTextItemProps } from "./LabelTextItem.props";

import styles from "./LabelTextItem.module.scss";
import { Paragraph } from "capitalrx-components-2.0/lib/typography";

interface BodyTextProps extends Partial<LabelTextItemProps> {
  readonly mainContent: string;
  readonly valueContent: ReactNode;
}

const BodyText = (props: BodyTextProps): JSX.Element => {
  const { type, hyperLink, mainContent, valueContent } = props;

  if (type === "url" && hyperLink) {
    return <a href={hyperLink}>{mainContent}</a>;
  } else if (type === "url") {
    return <a href={mainContent}>{mainContent}</a>;
  }
  return <span className={styles["label-text-item-body"]}>{valueContent}</span>;
};

/**
 * @deprecated
 */
const LabelTextItem: FC<LabelTextItemProps> = ({
  body,
  id,
  label,
  displayInline = false,
  isLoading = false,
  shouldHide,
  className,
  type,
  hyperLink,
  formatValue,
}: LabelTextItemProps): JSX.Element => {
  const containerClasses = cn(
    styles["label-text-item-wrapper"],
    {
      [styles["label-text-item-inline"]]: displayInline,
      [styles["label-text-item-hidden"]]: shouldHide && shouldHide(body),
    },
    className,
  );

  const labelClasses = cn(styles["label-text-item-label"]);
  let mainContent = body || "--";
  mainContent = formatValue && mainContent && typeof mainContent === "string" ? formatValue.replace("{{}}", mainContent) : mainContent;

  let paragraphContent = null;
  let valueContent: ReactNode = null;

  if (isLoading) {
    paragraphContent = <Skeleton className={styles["label-text-item-skeleton-label"]} />;
    valueContent = <Skeleton className={styles["label-text-item-skeleton-body"]} />;
  } else {
    paragraphContent = label;
    valueContent = mainContent;
  }

  return (
    <div id={`${id}-label-text-item-container`} className={containerClasses} data-testid={`test__${id}-label-text-item`}>
      <Paragraph className={labelClasses}>
        {paragraphContent}
      </Paragraph>
      <BodyText
        valueContent={valueContent}
        type={type}
        hyperLink={hyperLink}
        mainContent={typeof mainContent === "string" ? mainContent : ""}
      />
    </div>
  );
};

export default LabelTextItem;
